// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__CXuMA","gfeWrapper":"CalendarEvent_gfeWrapper__JoKem"};